module.exports = __webpack_public_path__ + "media/images/logo_bg-43248f3b8b335ce6d9cfeb3edcff902a.gif";